"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeNode = exports.TreeNodeType = void 0;
var TreeNodeType;
(function (TreeNodeType) {
    TreeNodeType["PARENTHESIS_NODE"] = "PARENTHESIS_NODE";
    TreeNodeType["PLUS_MINUS_NODE"] = "PLUS_MINUS_NODE";
    TreeNodeType["POW_NODE"] = "POW_NODE";
    TreeNodeType["SIGNED_NODE"] = "SIGNED_NODE";
    TreeNodeType["TIMES_DIV_NODE"] = "TIMES_DIV_NODE";
    TreeNodeType["BOOLEAN_NODE"] = "BOOLEAN_NODE";
    TreeNodeType["COLUMN_NODE"] = "COLUMN_NODE";
    TreeNodeType["COMPARISON_NODE"] = "COMPARISON_NODE";
    TreeNodeType["CONCRETE_NODE"] = "CONCRETE_NODE";
    TreeNodeType["CONSTANT_NODE"] = "CONSTANT_NODE";
    TreeNodeType["FORMULA_NODE"] = "FORMULA_NODE";
    TreeNodeType["SYMBOL_NODE"] = "SYMBOL_NODE";
    TreeNodeType["SIMPLE_FORMULA_NODE"] = "SIMPLE_FORMULA_NODE";
    TreeNodeType["ARRAY_NODE"] = "ARRAY_NODE";
})(TreeNodeType = exports.TreeNodeType || (exports.TreeNodeType = {}));
class TreeNode {
    _parent;
    _originalNode;
    _argsStartPosition;
    _argsEndPosition;
    _tokenStartPosition;
    _tokenEndPosition;
    _startPosition;
    _endPosition;
    _treeNodeType;
    constructor(originalNode, parent) {
        if (parent)
            this._parent = parent;
        this._originalNode = originalNode;
    }
    get startPosition() {
        return this._startPosition;
    }
    get endPosition() {
        return this._endPosition;
    }
    get treeNodeType() {
        return this._treeNodeType;
    }
    get argsStartPosition() {
        return this._argsStartPosition;
    }
    get argsEndPosition() {
        return this._argsEndPosition;
    }
    get tokenStartPosition() {
        return this._tokenStartPosition;
    }
    get tokenEndPosition() {
        return this._tokenEndPosition;
    }
}
exports.TreeNode = TreeNode;
